import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';
import { wrapAuthFetch } from 'util/api';

import { openConfirm } from './confirm';

export const getUser = createAction('GET_USER', async () => {
	const { status, data } = await wrapAuthFetch('user/ec/me');

	if (status !== 200) {
		return { data: {} };
	}

	return { data };
});

const { API_ENDPOINT } = process.env;

const cancelPurchase = createAction('CANCEL_PURCHASE', () => () =>
	window.open(`${API_ENDPOINT}/member`, '_self'),
);

const confirmCancelPurchase = createAction('CONFIRM_CANCEL_PURCHASE', () => dispatch =>
	dispatch(
		openConfirm(
			'提醒您',
			'您的會員資料還未填寫齊全，或未完成信箱、手機驗證，請先前往會員專區填寫完成。',
			cancelPurchase(),
		),
	),
);

const reducer = {
	user: handleActions(
		{
			GET_USER_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
			}),
		},
		{
			data: {
				id: 0,
				fb_id: 0,
				google_id: 0,
				email: '',
				type: '',
				name: '',
				mobile: '',
			},
		},
	),
};

const mapHooksToState = createSelector(
	state => state.user.data,
	data => data,
);

export const useUser = () => useRedux(mapHooksToState, { confirmCancelPurchase });

export default { reducer };
